<template>
  <v-cotainer>
    <v-layout row wrap> 
      <v-flex xs12 sm12 md12>
        <v-toolbar class="primary white--text">
          <v-toolbar-title class="headline text-xs-center">
            Staff Attendance
          </v-toolbar-title>
          <v-spacer></v-spacer>
            <v-text-field
              prepend-inner-icon="search"
              solo
              outlined
              clearable 
              label="Search Staff" 
              @keyup.native="keymonitor($event)" />
          <!-- </div> -->
          <v-spacer></v-spacer>
          <v-card-actions class="justify-center">
            <v-btn outline @click="addHr" class="white--text" :disabled="!hasHrAddPermission">
              <v-icon left dark>add</v-icon>
                New Staff 
            </v-btn>
          </v-card-actions>
        </v-toolbar>
        <v-toolbar style="margin-top:8px;" >
            <v-flex xs12 sm3 md3 style="margin-left: -10px;">
                <v-select
                :items="items1"
                label="Search Role"
                outline
                ></v-select>
            </v-flex>
            <v-flex xs12 sm3 md3 style="margin-left: 10px;">
            <v-select
                :items="items2"
                label="Search Month"
                outline
            ></v-select>
            </v-flex>
            </v-toolbar>
            <v-toolbar class="white--text">
            <v-radio-group row style="margin-top:18px;">
                <v-radio label="Present" value="radio-1"></v-radio>
                <v-radio label="Absent" value="radio-2"></v-radio>
                <v-radio label="Leave" value="radio-3"></v-radio>
                <v-radio label="Half Day" value="radio-4"></v-radio>
                <v-radio label="Late" value="radio-4"></v-radio>
            </v-radio-group>
            </v-toolbar>
        <v-data-table
          :headers="hrListHeader"
          :items="hrListByBrand"
          hide-actions
          class="elevation-1 dashboardHead"
        >
          <template slot="items" slot-scope="props">
            <td>
              <b>{{ props.item['.key']}}</b>
            </td>
            <td>
              <b>{{ props.item['name']}}</b>
              <br/>
              <b class="font-weight-light">{{ props.item['description'] }}</b> 
                -
              <b class="font-weight-light">{{ props.item['gender']}}</b>
                -
              <b class="font-weight-light">{{ props.item['marital']}}</b>
                -
              <b class="font-weight-light">{{ props.item.staffDesignationCategory}}</b>
            </td>
            
            <td>
              <b>{{ props.item['Designation']}}</b>
            </td>
            <td>
              <b>{{ props.item.staffDesignationCategory}}</b>
            </td>
            <td>
              <b>{{ props.item['age']}} - {{ props.item['Gender']}}</b>
            </td>
            
            <td>
              <b class="info--text font-weight-bold" >{{props.item['basicSalary']}} </b>
            </td>
            <td>
              <b class="primary--text font-weight-bold">{{props.item['netSalary']}}</b>
            </td>
            <td>
              <b class="green--text font-weight-bold" >{{props.item['epfAmount']}}</b>
            </td>
            <td>
              <b class="green--text font-weight-bold" >{{props.item['esiAmount']}}</b>
            </td>
            <td>
              <b class="green--text font-weight-bold" >{{props.item['tdsAmount']}}</b>
            </td>
            <td>
              <b class="green--text font-weight-bold" >{{props.item['casualLeave']}}</b>
            </td>
            <td>
              <b class="green--text font-weight-bold" >{{props.item['hra']}}</b>
            </td>
            <td>
              <b class="green--text font-weight-bold" >{{props.item['generalConveyance']}}</b>
            </td>
            <td>
              <b class="green--text font-weight-bold" >{{props.item['medicalConveyance']}}</b>
            </td>
            <td>
              <b class="green--text font-weight-bold" >{{props.item['specialConveyance']}}</b>
            </td>
            <td>
              <b class="green--text font-weight-bold" >{{props.item['bankName']}}</b>
            </td>
            <td>
              <b class="green--text font-weight-bold" >{{props.item['accountHolderName']}}</b>
            </td>
            <td>
              <b class="green--text font-weight-bold" >{{props.item['accountType']}}</b>
            </td>
            <td>
              <b class="green--text font-weight-bold" >{{props.item['accountNumber']}}</b>
            </td>
            <td>
              <b class="green--text font-weight-bold" >{{props.item['accountLocation']}}</b>
            </td>
            <td>
              <b class="green--text font-weight-bold" >{{props.item['ifsccode']}}</b>
            </td>

            <td>
              <b class="green--text font-weight-bold" >{{props.item['email']}}</b>
            </td>
            <td>
              <b class="green--text font-weight-bold" >{{props.item['mobile']}}</b>
            </td>

            <td>
              <v-btn :disabled="!hasHrTransferPermission" icon class="mx-0" @click="openTansferDialog(props.item)">
                <v-icon color="teal">double_arrow</v-icon>
              </v-btn>
            </td>
            <!-- <td class="justify-center layout px-0">
              <v-btn icon class="mx-0" @click="openBatchDialog(props.item)">
                <v-icon color="teal">add</v-icon>
              </v-btn>
              <v-btn icon class="mx-0" @click="viewHrByBatch(props.item)">
                <v-icon color="blue">remove_red_eye</v-icon>
              </v-btn>
            </td> -->
            <td>
              <v-btn :disabled="!hasHrEditPermission" icon class="mx-0" @click="editHr(props.item)">
                <v-icon color="teal">edit</v-icon>
              </v-btn>
            </td>
            <td>
              <v-btn :disabled="!hasHrDeletePermission" icon class="mx-0" @click="deleteHr(props.item)">
                <v-icon color="pink">delete</v-icon>
              </v-btn>
            </td>
            <td>
              <v-btn icon class="mx-0" @click="openDamageDialog(props.item)">
                <v-icon color="red">warning</v-icon>
              </v-btn>
            </td>
          </template>
          <template slot="no-data">No Items</template>
        </v-data-table>
      </v-flex>
    </v-layout>
    <v-dialog v-model="addHrDialog" persistent fullscreen hide-overlay>
      <v-card>
        <v-card-title class="primary white--text">
          <span class="headline">Staff Details</span>
          <v-spacer />
          <v-btn icon dark @click.native="addHrDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
        
        <v-stepper v-model="stepper" vertical>
            <v-stepper-step :complete="stepper > 1" step="1">Step 1: Enter Personal Information <h3 class = "error--text text--darken-4">{{duplicateError}}</h3></v-stepper-step>
            
            <v-stepper-content step="1">
              <v-card class="mb-12" style="height:100%">
                <v-card-text>
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex xs12 sm6 md6>       
                        <v-combobox
                          prepend-icon="account_box"
                          v-model="currentHr.name"
                          :items="hrListByBrand"
                          :return-object="false"
                          item-text="name"
                          item-value="name"
                          @change="duplicateCheck()"
                          label="Staff Name"
                          placeholder="Enter Staff Name"
                        ></v-combobox>
                      </v-flex>  
                      <v-flex xs12 sm2 md2>
                        <v-text-field
                          prepend-icon="font_download"
                          ref="age"
                          type="number"
                          v-model="currentHr.age"
                          :rules="age.rules"
                          label="Age"
                          maxlength="3"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm2 md2>
                        <v-select 
                          prepend-icon="wc"
                          v-model="currentHr.gender" :items="gGender" label="Gender"></v-select>
                      </v-flex>
                      <v-flex xs12 sm2 md2>
                        <v-select 
                          prepend-icon="nature_people"
                          v-model="currentHr.marital" 
                          :items="gMarital" 
                          label="Marital Status"></v-select>
                      </v-flex>  
                      <v-flex xs12 sm6 md3>
                        <v-select
                          prepend-icon="perm_identity"
                          v-model="identityType.value" :items="gIdentityType" clearable label="Identity Type"></v-select>
                      </v-flex>
                      <v-flex xs12 sm6 md3 v-if="identityType.value">
                        <v-text-field
                          prepend-icon="picture_in_picture"
                          ref="identityNumber"
                          :error-messages="identityNumeberError"
                          v-model="identityNumber.value"
                          :rules="identityNumber.rules"
                          label="Identity Number"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md3>
                        <v-text-field
                          prepend-icon="phone"
                          type="number"
                          ref="mobile"
                          v-model="currentHr.mobile"
                          :rules="mobile.rules"
                          label="Mobile"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md3>
                        <v-text-field 
                          prepend-icon="email"
                          ref="email" type="email" v-model="currentHr.email" :rules="email.rules" label="Email"></v-text-field>
                      </v-flex>
                      <!-- <v-flex xs12 sm4 md4>
                        <v-select
                            prepend-icon="group_work"
                            dense
                            :items="hrGroupListByBrand"
                            label="Select Group"
                            item-text="text"
                            item-value="value"
                            v-model="currentHr.hrGroup"
                          ></v-select>
                      </v-flex> -->
                       <v-flex xs12 sm4 md4>
                        <v-select
                            dense
                            prepend-icon="policy"
                            :items="firmsByBrand"
                            label="Select Firm"
                            item-text="text"
                            item-value="value"
                            v-model="currentHr.firm"
                          ></v-select>
                      </v-flex>
                      <v-flex xs12 sm5 md5>
                        <v-text-field
                          prepend-icon="info"
                          type="text"
                          label="Staff Description"
                          v-model="currentHr.description"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm3 md3>
                        <v-menu
                          :close-on-content-click="false"
                          v-model="datepicker"
                          :nudge-right="40"
                          lazy
                          transition="scale-transition"
                          offset-y
                          full-width
                          min-width="290px"
                        >
                          <v-text-field
                            slot="activator"
                            v-model="currentHr.dateOfBirth"
                            label="Date of Birth "
                            prepend-icon="event"
                            readonly
                          ></v-text-field>
                          <v-date-picker v-model="currentHr.dateOfBirth" @input="datepicker = false"></v-date-picker>
                        </v-menu>
                    </v-flex>
                      <!-- <v-flex xs12 sm4 md4>
                        <v-text-field
                          type="text"
                          label="Hr Barcode"
                          v-model="currentHr.barcode"
                        ></v-text-field>
                      </v-flex> -->
                      <!-- <v-flex xs12 sm4 md4>
                           <v-autocomplete
                              v-if="currentHr.businessType == 'Medical/Pesticides'"
                              :items="compositionSuggestions"
                              v-model="currentHr.composition"
                              label="Select or Add Composition"
                              @keyup.native.enter="addComposition"
                              multiple
                            ></v-autocomplete>
                      </v-flex> -->  
                      
                      
                      <v-flex xs12 sm6 md6>
                        <v-textarea
                          background-color="grey lighten-1"
                          color="black"
                          class="address"
                          box
                          name="input-7-1"
                          prepend-icon="store"
                          type="text"
                          label="Current Address"
                          v-model="currentHr.currentAddressDescription"
                        ></v-textarea>
                      </v-flex>
                      <v-flex xs12 sm6 md6>
                        <v-textarea
                          background-color="grey darken-1"
                          color="black"
                          box
                          name="input-7-1"
                          prepend-icon="store"
                          type="text"
                          label="Permanent Address"
                          v-model="currentHr.currentPermanentDescription"
                        ></v-textarea>
                      </v-flex>
                      <!-- <v-flex xs12 sm3 md3 v-if="!currentHr.unitsDeatilsAdded">
                        <v-select
                          dense
                          :items="units"
                          label="Select unit"
                          v-model="currentHr.unit"
                        ></v-select>
                      </v-flex> 
                      <v-layout wrap>
                        <v-flex xs12 sm12 md12>
                          <v-select
                            dense
                            :items="[
                              {
                                text: 'Yes',
                                value: true
                              },
                              {
                                text: 'No',
                                value: false
                              },
                              ]"
                            label="Do you have Muliple units Of Hr?"
                            v-model="currentHr.unitsDeatilsAdded"
                          ></v-select>
                        </v-flex>
                      </v-layout>
                      <v-flex xs12 v-if="currentHr.unitsDeatilsAdded">
                      <v-layout wrap>
                        <template v-for="unitDetail in currentHr.unitsDetails">
                           <v-flex :key="unitDetail.order + 'flex1'" xs2>
                           <v-select
                              dense
                              :items="units"
                              :key="unitDetail.order + 'unit'"
                              :label="'Select unit ( ' + unitDetail.order + '.)'"
                              v-model="unitDetail.unit"
                            ></v-select>
                           </v-flex>
                             <v-flex :key="unitDetail.order + 'flex3'" xs2>
                              <v-text-field
                                type="number"
                                :key="unitDetail.order + 'rateP'"
                                v-if="unitDetail.unit"
                                v-model="unitDetail.purchasingPrice"
                                :label="'Purchasing Rate of 1 '+ unitDetail.unit"
                              ></v-text-field>
                            </v-flex>
                             <v-flex :key="unitDetail.order + 'flex6'" xs2>
                              <v-text-field
                                type="number"
                                :key="unitDetail.order + 'rateS'"
                                v-if="unitDetail.unit"
                                v-model="unitDetail.sellingPrice"
                                :label="'Selling Rate of 1 '+ unitDetail.unit"
                              ></v-text-field>
                            </v-flex>
                            <v-flex :key="unitDetail.order + 'flex2'" xs2>
                              <v-text-field
                                type="number"
                                v-if="!unitDetail.isFirst"
                                :key="unitDetail.order + 'quantity'"
                                v-model="unitDetail.quantity"
                                :label="'Quantity'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex :key="unitDetail.order + 'flex4'" xs2>
                              <v-btn
                                v-if="unitDetail.isLast && unitDetail.unit" :key="unitDetail.order + 'add'"
                                  flat
                                  class="primary white--text"
                                  @click="addUnitData(unitDetail)"
                                  >Add next unit 
                                <v-icon>add</v-icon>
                              </v-btn>
                            </v-flex>
                            <v-flex :key="unitDetail.order + 'flex5'" xs2>
                               <v-btn
                                  v-if="unitDetail.isLast && !unitDetail.isFirst" :key="unitDetail.order + 'close'"
                                  class="primary white--text"
                                  @click="removeUnitData(unitDetail)"
                                  >Remove
                                <v-icon>close</v-icon>
                              </v-btn>
                            </v-flex>
                        </template>
                      </v-layout>
                      </v-flex> -->
                    </v-layout>
                  </v-container>
                  <v-btn color="primary" @click="stepper = 2">Next</v-btn>
                </v-card-text>
              </v-card>
            </v-stepper-content>

            <v-stepper-step :complete="stepper > 2" step="2">Step 2 : Enter your Bank Details</v-stepper-step>

            <v-stepper-content step="2">
              <v-card class="mb-12" style="height:100%">
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12 sm12 md12>
                      <v-select
                        dense
                        :items="[
                          {
                            text: 'Yes',
                            value: true
                          },
                          {
                            text: 'No',
                            value: false
                          },
                          ]"
                        label="Enter Bank Details?"
                        v-model="isBankDetails"
                      ></v-select>
                    </v-flex>
                  </v-layout>
                  <v-layout wrap v-if="isBankDetails">
                    <v-flex xs12 sm3 md3 v-if="isBankDetails">                                  
                      <v-select
                        item-text="name"
                        item-value="id"
                        :items="currentBankName"
                        v-model="currentHr.bankName"    
                        label="Choose Bank"
                      ></v-select>
                      </v-flex>
                      <v-flex xs12 sm3 md3>
                      <v-select
                        item-text="name"
                        item-value="id"
                        :items="currentAccountType"
                        v-model="currentHr.accountType"
                        label="Choose Account Type"
                      ></v-select>
                      </v-flex>
                      <v-flex xs12 sm3 md3>
                        <v-text-field 
                          label="Account Holder Name"  
                          v-model="currentHr.accountHolderName" 
                          :disabled="accholderdisabled">
                        </v-text-field>
                      </v-flex>
                      <v-flex xs12 sm3 md3>
                        <v-text-field 
                          label="Account Number"  
                          v-model="currentHr.accountNumber" >
                        </v-text-field>
                      </v-flex>
                      <v-flex xs12 sm3 md3>
                        <v-text-field 
                          label="IFSC code" 
                          @change="getBankDetailsFromIFSC(false)" 
                          :rules="IFSC_Rules" 
                          v-model="ifsccode" ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm3 md3>
                        <v-textarea 
                          background-color="grey darken-1"
                          color="black" 
                          label="Location" 
                          box  
                          v-model="accountLocation" ></v-textarea>
                      </v-flex>
                  </v-layout>
                </v-container>
                <v-card-text>
                  <v-btn color="primary" @click="stepper = 3">Next</v-btn>
                  <v-btn text @click="stepper = 1">Back</v-btn>
                </v-card-text>
              </v-card>
            </v-stepper-content>

            <v-stepper-step :complete="stepper > 3" step="3">Step 3 : Enter your Professional Details</v-stepper-step>

            <v-stepper-content step="3">
              <v-card class="mb-12" style="height:100%">
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12 sm12 md12>
                      <v-select
                        dense
                        :items="[
                          {
                            text: 'Yes',
                            value: true
                          },
                          {
                            text: 'No',
                            value: false
                          },
                          ]"
                        label="Enter Professional Details?"
                        v-model="isProfessionalDetails"
                      ></v-select>
                    </v-flex>
                  </v-layout>
                  <v-layout wrap v-if="isProfessionalDetails">
                      <!-- <v-flex xs12 sm3 md3 v-if="isProfessionalDetails">
                        <v-text-field label="EPF Number"  v-model="accountHolderName" :disabled="accholderdisabled"></v-text-field>
                      </v-flex> -->
                      <v-flex xs12 sm3 md3>
                        <v-select
                          dense
                          :items="Designations"
                          label="Select Role"
                          v-model="currentHr.Designation"
                        ></v-select>
                      </v-flex>
                      <v-flex xs12 sm3 md3>
                        <v-select
                          v-if="currentHr.Designation === 'Teacher'"
                          type="number"
                          dense
                          :items="['PPRT','PRT','TGT','PGT']"
                          v-model="currentHr.staffDesignationCategory"
                          :disabled="currentHr.Designation != 'Teacher'"
                          label="Teacher Classification"
                        ></v-select>
                      </v-flex>    
                      <v-flex xs12 sm3 md3  v-if="isProfessionalDetails">
                        <v-text-field label="EPF Number"  v-model="epfnumber" ></v-text-field>
                      </v-flex>
                      <!-- <v-flex xs12 sm3 md3>
                        <v-text-field label="Basic Salary"  v-model="basicSalary" ></v-text-field>
                      </v-flex> -->
                      <v-flex xs12 sm3 md3>                                  
                      <v-select
                        item-text="name"
                        item-value="id"
                        :items="currentContractType"
                        v-model="contractType"
                        
                        label="Choose Contract Type"
                      ></v-select>
                      </v-flex>
                      <v-flex xs12 sm3 md3>                                  
                      <v-select
                        item-text="name"
                        item-value="id"
                        :items="currentWorkShift"
                        v-model="workShift"
                        label="Choose WorkshiftType"
                      ></v-select>
                      </v-flex>
                      <v-flex xs12 sm3 md3>
                        <v-text-field
                          ref="age"
                          type="number"
                          v-model="workExperience.value"
                          :rules="workExperience.rules"
                          label="Work Experience(in Years)"
                          maxlength="3"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm3 md3>
                        <v-text-field
                          type="number"
                          v-model="currentHr.StaffId"
                          label="Staff ID"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm3 md3>
                        <v-menu
                          :close-on-content-click="false"
                          v-model="datepicker1"
                          :nudge-right="40"
                          lazy
                          transition="scale-transition"
                          offset-y
                          full-width
                          min-width="290px"
                        >
                          <v-text-field
                            slot="activator"
                            v-model="currentHr.dateOfJoining"
                            label="Date of Joining "
                            prepend-icon="event"
                            readonly
                          ></v-text-field>
                          <v-date-picker v-model="currentHr.dateOfJoining" @input="datepicker1= false"></v-date-picker>
                        </v-menu>
                    </v-flex>
                    <!-- <v-flex xs12 sm3 md3>                                  
                      <v-select
                        item-text="name"
                        item-value="id"
                        :items="currentEmployeeQualification"
                        v-model="employeeQualification"    
                        label="Extra Options"
                      ></v-select>
                      </v-flex> -->
                      <!-- <v-flex xs12 sm3 md3>
                        <v-text-field label="IFSC code" @change="getBankDetailsFromIFSC(false)" :rules="IFSC_Rules" v-model="ifsccode" ></v-text-field>
                      </v-flex> -->
                      <!-- <v-flex xs12 sm3 md3>
                        <v-textarea label="Location" box  v-model="accountLocation" ></v-textarea>
                      </v-flex> -->
                  </v-layout>
                </v-container>
                <v-card-text>
                  <v-btn color="primary" @click="stepper = 4">Next</v-btn>
                  <v-btn text @click="stepper = 2">Back</v-btn>
                </v-card-text>
              </v-card>
            </v-stepper-content>

            <v-stepper-step :complete="stepper > 4" step="4">Step 4 : Enter your Salary Details</v-stepper-step>
            <v-stepper-content step="4">
              <v-card class="mb-12" style="height:100%">
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12 sm12 md12>
                      <v-select
                        dense
                        :items="[
                          {
                            text: 'Yes',
                            value: true
                          },
                          {
                            text: 'No',
                            value: false
                          },
                          ]"
                        label="Enter Salary Details?"
                        v-model="isSalaryDetails"
                      ></v-select>
                    </v-flex>
                  </v-layout>
                  <v-layout wrap v-if="isSalaryDetails">
                      <!-- <v-flex xs12 sm3 md3 v-if="isSalaryDetails">
                        <v-text-field label="EPF Number"  v-model="accountHolderName" :disabled="accholderdisabled"></v-text-field>
                      </v-flex> -->
                      <!-- <v-flex xs12 sm3 md3>
                        <v-select
                          dense
                          :items="Designations"
                          label="Select Role"
                          v-model="currentHr.Designation"
                        ></v-select>
                      </v-flex>
                      <v-flex xs12 sm3 md3>
                        <v-select
                          v-if="currentHr.Designation === 'Teacher'"
                          type="number"
                          dense
                          :items="['PGT','TGT','UGT']"
                          v-model="currentHr.staffDesignationCategory"
                          :disabled="currentHr.Designation != 'Teacher'"
                          label="Teacher Classification"
                        ></v-select>
                      </v-flex>    
                      <v-flex xs12 sm3 md3  v-if="isProfessionalDetails">
                        <v-text-field label="EPF Number"  v-model="epfnumber" ></v-text-field>
                      </v-flex> -->
                      <v-flex xs12 sm3 md3>
                        <v-text-field label="Basic Salary"  v-model="currentHr.basicSalary" ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm3 md3>
                        <v-text-field label="HRA(House Rent Allowance)"  v-model="currentHr.hra" ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm3 md3>
                        <v-text-field label="Genreal Conveyance"  v-model="currentHr.generalConveyance" ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm3 md3>
                        <v-text-field label="Medical Conveyance"  v-model="currentHr.medicalConveyance" ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm3 md3>
                        <v-text-field label="Special Conveyance"  v-model="currentHr.specialConveyance" ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm3 md3>
                        <v-text-field label="Casual Leave"  v-model="currentHr.casualLeave" ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm3 md3>
                        <v-text-field label="EPF Amount"  v-model="currentHr.epfAmount" ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm3 md3>
                        <v-text-field label="ESI[Employee State Tax]"  v-model="currentHr.esiAmount" ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm3 md3>
                        <v-text-field label="TDS[Tax Deduction at Source]"  v-model="currentHr.tdsAmount" ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm3 md3>
                        <v-text-field label="Professional Tax"  v-model="currentHr.professionalTaxAmount" ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm3 md3>
                        <v-text-field label="Net Salary"  v-model="currentHr.netSalary" ></v-text-field>
                      </v-flex>
                      <!-- <v-flex xs12 sm3 md3>                                  
                      <v-select
                        item-text="name"
                        item-value="id"
                        :items="currentContractType"
                        v-model="contractType"
                        
                        label="Choose Contract Type"
                      ></v-select>
                      </v-flex>
                      <v-flex xs12 sm3 md3>                                  
                      <v-select
                        item-text="name"
                        item-value="id"
                        :items="currentWorkShift"
                        v-model="workShift"
                        
                        label="Choose WorkshiftType"
                      ></v-select>
                      </v-flex>
                      <v-flex xs12 sm1 md1>
                        <v-text-field
                          ref="age"
                          type="number"
                          v-model="workExperience.value"
                          :rules="workExperience.rules"
                          label="Work Experience"
                          maxlength="3"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm2 md2>
                        <v-text-field
                          type="number"
                          v-model="currentHr.StaffId"
                          label="Staff ID"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm3 md3>
                        <v-menu
                          :close-on-content-click="false"
                          v-model="datepicker1"
                          :nudge-right="40"
                          lazy
                          transition="scale-transition"
                          offset-y
                          full-width
                          min-width="290px"
                        >
                          <v-text-field
                            slot="activator"
                            v-model="currentHr.dateOfJoining"
                            label="Date of Joining "
                            prepend-icon="event"
                            readonly
                          ></v-text-field>
                          <v-date-picker v-model="currentHr.dateOfJoining" @input="datepicker1= false"></v-date-picker>
                        </v-menu>
                    </v-flex>
                    <v-flex xs12 sm3 md3>                                  
                      <v-select
                        item-text="name"
                        item-value="id"
                        :items="currentEmployeeQualification"
                        v-model="employeeQualification"      
                        label="Extra Options"
                      ></v-select>
                    </v-flex> -->
                      <!-- <v-flex xs12 sm3 md3>
                        <v-text-field label="IFSC code" @change="getBankDetailsFromIFSC(false)" :rules="IFSC_Rules" v-model="ifsccode" ></v-text-field>
                      </v-flex> -->
                      <!-- <v-flex xs12 sm3 md3>
                        <v-textarea label="Location" box  v-model="accountLocation" ></v-textarea>
                      </v-flex> -->
                  </v-layout>
                </v-container>
                <v-card-text>
                  <v-btn color="primary" @click="stepper = 5">Next</v-btn>
                  <v-btn text @click="stepper = 3">Back</v-btn>
                </v-card-text>
              </v-card>
            </v-stepper-content>

            <v-stepper-step :complete="stepper > 5" step="5">Step 5 Do you want to Upload Documents </v-stepper-step>

            <v-stepper-content step="5">
              <v-card class="mb-12" style="height:100%">
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12 sm6 md4>
                      <v-select
                        dense
                        :items="[
                          {
                            text: 'Yes',
                            value: true
                          },
                          {
                            text: 'No',
                            value: false
                          },
                        ]"
                        label="Do you want to add Documents like Resume,CV,Certificates,Letters,etc?"
                        v-model="isDocumentAvailable"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 sm6 md4 v-if="isDocumentAvailable">
                      <v-select
                        dense
                        :disabled="true"
                        :items="units"
                        label="Select unit"
                        :value="this.currentHr.unitsDeatilsAdded ? this.getLastUnit : this.currentHr.unit"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 sm6 md4 v-if="isDocumentAvailable">
                      <v-select
                        dense
                        :items="['PGT','TGT','UGT']"
                        v-model="currentHr.staffDesignationCategory"
                        :disabled="true"
                        label="Teacher Classification"
                      ></v-select>
                    </v-flex>
                  </v-layout>
                  <v-layout wrap v-if="isDocumentAvailable">
                    <v-flex xs12 sm6 md6>
                      <v-text-field
                        type="number"
                        v-model="currentHr.purchasingPrice"
                        label="Purchasing Price [Excluding GST]"
                      ></v-text-field>
                    </v-flex>
                     <v-flex xs12 sm6 md6>
                      <v-text-field
                        type="number"
                        :disabled="true"
                        :value="currentHr.staffDesignationCategory ? (Number.parseFloat((currentHr.purchasingPrice * currentHr.staffDesignationCategory)/100) + Number.parseFloat(currentHr.purchasingPrice)).toFixed(2) : currentHr.purchasingPrice"
                        label="Purchasing Price [Including GST]"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md6>
                      <v-text-field
                        type="number"
                        v-model="currentHr.sellingPrice"
                        label="Selling Price [Excluding GST]"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md6>
                      <v-text-field
                        type="number"
                        :disabled="true"
                        :value="currentHr.staffDesignationCategory ? (Number.parseFloat((currentHr.sellingPrice * currentHr.staffDesignationCategory)/100) + Number.parseFloat(currentHr.sellingPrice)).toFixed(2) : currentHr.sellingPrice"
                        label="Selling Price [Including GST]"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-container>
                <v-card-text>                  
                  <v-btn color="primary" @click="saveHr" v-if="!currentHr['.key']">Save</v-btn>
                  <v-btn text @click="stepper = 4">Back</v-btn>
                  <v-btn
                    color="primary"
                    @click="updateHr"
                    v-if="!!currentHr['.key']"
                  >Update</v-btn>
                </v-card-text>
              </v-card>
            </v-stepper-content>
          </v-stepper>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Start Hr Transfer Dialog -->
    <!-- <v-dialog v-model="transferDialog" persistent max-width="1000px">
      <v-card persistent>
        <v-card-title class="primary white--text">
          <span class="headline">Shift/Transfer Items</span>
            <v-spacer></v-spacer>
          </v-card-title>

          <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm6 md6>
                <v-combobox
                  v-model="hrToTansfer"
                  :items="hrListByBrand"
                  :return-object="true"
                  item-text="name"
                  label="Hr"
                ></v-combobox>
              </v-flex>
              
              <v-flex xs6 sm6 md6>
                <v-menu
                  :close-on-content-click="false"
                  v-model="datepickerTransfer"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="transferDate"
                    label="Date"
                    prepend-icon="event"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="transferDate" @input="datepickerTransfer = false"></v-date-picker>
                </v-menu>
              </v-flex>
              
                <v-flex xs6 sm6 md6>
                  <v-combobox
                    v-model="currentGodawn"
                    :items="godawnByBrand"
                    :return-object="true"
                    item-text="godawnName"
                    label="Godawn"
                  ></v-combobox>
                </v-flex>
              
                <v-flex xs6 sm6 md6>
                  <v-text-field
                    v-model="transferQuantity"
                    type="number"
                    label="Quantity"
                  ></v-text-field>
                </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                @click="transferDialog = false"
                flat
              >Cancel</v-btn>
              <v-btn
                color="blue darken-1"
                @click="transferToGodawn()"
                flat
              >Move</v-btn>
            </v-card-actions>
          </v-card>
      </v-dialog> -->
      <!-- End of Hr Transfer Dialog -->

      <!-- Start of Batch Dialog -->
      <!-- <v-dialog v-model="batchDialog" persistent max-width="1000px">
      <v-card persistent>
        <v-card-title class="primary white--text">
          <span class="headline">Add Batch Details</span>
            <v-spacer></v-spacer>
          </v-card-title>

          <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs3 sm3 md3>
                <v-combobox
                  v-model="hrToBatch"
                  :items="hrListByBrand"
                  :return-object="true"
                  item-text="name"
                  label="Hr"
                ></v-combobox>
              </v-flex>
              <v-flex xs2 sm2 md2>
                  <v-text-field
                    v-model="batchNumber"
                    type="text"
                    label="BatchNumber"
                  ></v-text-field>
                </v-flex>
              
              <v-flex xs3 sm3 md3>
                <v-menu
                  :close-on-content-click="false"
                  v-model="datepickerBatch"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="manufacuturingDate"
                    label="ManuFacturing Date"
                    prepend-icon="event"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="manufacuturingDate" @input="datepickerBatch = false"></v-date-picker>
                </v-menu>
              </v-flex>

              <v-flex xs3 sm3 md3>
                <v-menu
                  :close-on-content-click="false"
                  v-model="todatepickerBatch"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="expiryDate"
                    label="Expiry Date"
                    prepend-icon="event"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="expiryDate" @input="todatepickerBatch = false"></v-date-picker>
                </v-menu>
              </v-flex>

              <v-flex xs1 sm1 md1>
                  <v-text-field
                    v-model="batchQuantity"
                    type="number"
                    label="HrQuantity"
                  ></v-text-field>
              </v-flex>

            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
        <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            @click="batchDialog = false"
            flat
            >Cancel</v-btn>
            <v-btn
              color="blue darken-1"
              @click="addToBatch()"
              flat
            >Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog> -->
      <!-- End of Batch Dialog -->

      <!-- view Batch Dialog -->
      <!-- <v-dialog v-model="viewBatchDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card v-if="batchSelectedHr">
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="viewBatchDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Batch Details of 
              <b>{{ batchSelectedHr['name']}}</b>
                -
              <b class="font-weight-light">HSN: {{ batchSelectedHr['StaffId']}}</b>
                -
              <b class="font-weight-light">GST type: {{ batchSelectedHr['Designation']}}</b>
                -
              <b class="font-weight-light">GST Rate: {{ batchSelectedHr.staffDesignationCategory}}</b>
                -
              <b class="font-weight-light">UNI : {{ batchSelectedHr.unit}}</b>
          </v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-data-table
          :headers="hrListHeaderByBatch"
          :items="bachList"
          hide-actions
          class="elevation-1 dashboardHead"
        >
          <template slot="items" slot-scope="props">
            <td>
              <b>{{ props.item['batchNumber']}}</b>
            </td>
            <td>
              <b v-if="props.item['manufacturingDate']">{{ new Date(props.item['manufacturingDate']).toISOString().substr(0, 10)}}</b>
            </td>
            <td>
              <b v-if="props.item['expiryDate']">{{ new Date(props.item['expiryDate']).toISOString().substr(0, 10)}}</b>
            </td>
            <td>
              <b class="info--text font-weight-bold">{{ props.item['quantity'] }}</b>
            </td>
            
          </template>
          <template slot="no-data">No Items</template>
        </v-data-table>
      </v-card>
    </v-dialog> -->
    <!-- view Batch Dialog -->


    <!-- Start Damage dialog -->
    <!-- <v-dialog v-model="damageDialog" persistent max-width="1000px">
      <v-card persistent>
        <v-card-title class="primary white--text">
          <span class="headline">DamageList</span>
            <v-spacer></v-spacer>
          </v-card-title>

          <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm6 md6>
                <v-combobox
                  v-model="hrToDamage"
                  :items="hrListByBrand"
                  :return-object="true"
                  item-text="name"
                  label="Hr"
                ></v-combobox>
              </v-flex>
              
              <v-flex xs6 sm6 md6>
                <v-menu
                  :close-on-content-click="false"
                  v-model="datepickerDamage"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="damageDate"
                    label="Date"
                    prepend-icon="event"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="damageDate" @input="datepickerDamage = false"></v-date-picker>
                </v-menu>
              </v-flex>
                            
                <v-flex xs6 sm6 md6>
                  <v-text-field
                    v-model="damageQuantity"
                    type="number"
                    label="Damage Quantity"
                  ></v-text-field>
                </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                @click="damageDialog = false"
                flat
              >Cancel</v-btn>
              <v-btn
                color="blue darken-1"
                @click="transferToDamage()"
                flat
              >Save</v-btn>
            </v-card-actions>
          </v-card>
      </v-dialog> -->
      <!-- End of Damage Dialog -->

    <v-snackbar :timeout="timeout" top v-model="snackbar" color="primary">
      Thank You so Much 
      <!-- <h3 class="font-weight-bold"> 
        {{getSelectedbrandName}} </h3>  -->
        To make you serve Better.
    </v-snackbar>
  </v-cotainer>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
import axios from 'axios';

const mapGlobalGetters = createNamespacedHelpers("Global")["mapGetters"];
export default {
  data() {
    return {
      items1: ['All','Teacher', 'Peon', 'Manager', 'Accountant', 'Operator', 'Driver', 'Conductor', 'IT Department', 'Admin', ],
      items2: ['January', 'Februry', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      isBuyer: true,
      search : null,
      defaultFirm : null,
      compositionSuggestions : [],
      suggestionAdded : false,
      transferDialog : false,
      viewBatchDialog: false,
      batchDialog : false,
      damageDialog : false,
      stepper: 1,
      isBankDetails: false,
      isProfessionalDetails: false,
      isSalaryDetails: false,
      isDocumentAvailable: false,
      addHrDialog: false,
      hrToTansfer : null,
      hrToBatch : null,
      hrToDamage : null,
      datepickerTransfer : false,
      datepickerBatch : false,
      todatepickerBatch : false,
      datepickerDamage : false,
      currentGodawn : null,
      transferQuantity :0,
      batchQuantity :0,
      damageQuantity :0,
      batchNumber:"",
      brand : {},
      datepicker : false,
      datepicker1 : false,
      duplicateError : null,
    //   transferDate : new Date().toISOString().substr(0, 10),
    //   manufacuturingDate : new Date().toISOString().substr(0, 10),
    //   expiryDate : new Date().toISOString().substr(0, 10),
    //   damageDate : new Date().toISOString().substr(0, 10),
      currentHr: {
        name: "",
        age:0,
        gender:"",
        description: "",
        currentAddressDescription: "",
        currentPermanentDescription: "",
        currentWorkShift:"",
        currentAccountType: "",
        currentBankName:"",
        currentEmployeeQualification:"",
        currentContractType: "",
        StaffId: 0,
        Designation: "",
        staffDesignationCategory: "",
        unit: "",
        quantity: 0,
        brand: "",
        dateOfJoining : new Date().toISOString().substr(0, 10),
        dateOfBirth : new Date().toISOString().substr(0, 10),
        purchasingPrice: null,
        sellingPrice: null,
        openingBalance: null,
        gstValue : 0,
        basicPrice : 0,
        barcode:"",
        basicSalary: 0,
        netSalary: 0,
        generalConveyance: 0,
        specialConveyance: 0,
        medicalConveyance: 0,
        casualLeave: 0,
        epfAmount: 0,
        esiAmount: 0,
        tdsAmount: 0,
        professionalTaxAmount: 0,

        bankName: "",
        accountNumber: "",
        accountType: "",
        accountHolderName: "",
        accountLocation: "",
        ifsccode: "",

        hrGroup:null,

        mobile: {
        value: "",
        rules: [
          v =>{
            if(!v) {
              return true;
            } 
              else {
                return (/^$/.test(v) ||
                  /^(\+91|\+91\-|0)?[6789]\d{9}$/.test(v) ||
                  "Mobile number is wrong")
              }
            }
          ]
        },

        email: {
          value: "",
          rules: [
          v =>{
            if(!v) {
              return true;
            } 
            else {
              return (/^$/.test(v) ||
                /.@./.test(v) ||
                "E-mail must be valid")
              }
            }
          ]
        },
        
        unitsDetails : [
          {
            unit:'',
            isLast: true,
            isFirst:true,
            order : 1,
            quantity : 0,
            rate: true
          }
        ],
        unitsDeatilsAdded : false,
      },
      timeout : 3000,
      snackbar : false,
      hrList: [],
      hrListHeader: [
        { text: "Name - Description" , value: "Name" },
        { text: "Age", value: "age" },
        { text: "Role", value: "quantity" },
        { text: "Department", value: "quantity" },
        { text: "Designation", value: "quantity" },
        
        { text: "Basic Salary", value: "quantity" },
        { text: "Net Salary", value: "quantity" },
        { text: "EPF Amount", value: "quantity" },
        { text: "ESI Amount", value: "transfer" },
        { text: "TDS Amount", value: "transfer", },
        { text: "Pro Tax Amount", value: "edit" },
        { text: "HRA Amount", value: "delete" },
        { text: "General Con", value: "transfer" },
        { text: "Special Con", value: "quantity" },
        { text: "Medical Con", value: "quantity" },

        { text: "Bank Name", value: "transfer", },
        { text: "Account Holder Name", value: "edit" },
        { text: "Account Number", value: "delete" },
        { text: "Account Type", value: "transfer" },
        { text: "Account Location", value: "quantity" },
        { text: "IFSC Code", value: "quantity" },

        { text: "Mobile No", value: "quantity" },
        { text: "Email", value: "quantity" },
        { text: "Address", value: "quantity" },
        { text: "Transfer", value: "transfer" },
        { text: "Batch", value: "transfer", },
        { text: "Edit", value: "edit" },
        { text: "Delete", value: "delete" },
        { text: "Action", value: "transfer" },

      ],
      hrListHeaderByBatch: [
        { text: "Batch", value: "batch" },
        { text: "Manufacturing Date", value: "manuDate" },
        { text: "Expiry Date", value: "expiryDate" },
        { text: "Quantity", value: "quantity" },
      ],
      Designations: [
         {
          text: "Accountant",
          value: "Accountant"
         },
         {
          text: "Conductor",
          value: "Conductor"
         },
         {
          text: "DataEntry Operator",
          value: "DataEntryOperator"
         },
         {
          text: "Driver",
          value: "Driver"
         },
         {
          text: "Manager",
          value: "Manager"
         },
         {
           text: "Peon",
           value: "Peon"
         },
         {
           text: "Staff",
           value: "Staff"
         },
         {
          text: "Supervisor",
          value: "Supervisor"
         },
         {
           text: "Teacher",
           value: "Teacher"
         },
       ],
      age: {
        value: ""
      },
      workExperience: {
        value: ""
      },
      gender: {
        value: ""
      },
      marital: {
        value: ""
      },
      identityType: {
        value: ""
      },
      identityNumber: {
        value: ""
      },
      mobile: {
        value: "",
        rules: [
          v =>{
            if(!v) {
              return true;
            } 
              else {
                return (/^$/.test(v) ||
                  /^(\+91|\+91\-|0)?[6789]\d{9}$/.test(v) ||
                  "Mobile number is wrong")
              }
            }
        ]
      },
      email: {
        value: "",
        rules: [
        v =>{
          if(!v) {
            return true;
          } 
          else {
            return (/^$/.test(v) ||
              /.@./.test(v) ||
              "E-mail must be valid")
            }
          }
        ]
      },
      bachList : [],
      batchSelectedHr : null,
      bankName:null,
      accountType:null,
      accholderdisabled:false,
      contractType:null,
      workShift:null,
      employeeQualification: null,
      accountCategory:null,
      currentBankName:[
        'Allahabad Bank',
        'Andhra Bank',
        'Axis Bank',
        'Bandhan Bank',
        'Bank of India',
        'Bank Of Baroda',
        'Bank Of Maharastra',
        'Canara Bank',
        'Central Bank Of India',
        'Corporation Bank',
        'Dena Bank',
        'DCB bank',
        'Google Pay',
        'HDFC bank',
        'ICICI Bank',
        'Indian Overseas Bank',
        'Kotak Mahindra Bank',
        'Oriental Bank Of Commerce',
        'Paytm',
        'Phone Pe',
        'Punjab National Bank',
        'Punjab and Sind Bank',
        'State Bank Of India',
        'UCO Bank',
        'Union Bank Of India',
        'Vijaya Bank',
        'Yes Bank',
      ],
      currentAccountType:[
        'Saving A/C',
        'Current A/C',
        'Overdraft A/C',
        'Loan A/C',
      ],
      currentContractType:[
        'Permanent',
        'Contractual',
        'Temporary',
        'Extra',
      ],
      currentWorkShift:[
        'Day',
        'Afternoon',
        'Evening',
        'Night',
      ],
      currentEmployeeQualification: [
        'Option 1',
        'Option 2',
        'Option 3',
      ],
      IFSC_Rules: [
        v => {
            // let reg = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;
            let reg = /^([a-zA-Z]){4}([0]){1}([a-zA-Z0-9]){6}?$/;
            return (
              v == undefined ||
              /^$/.test(v) ||
              reg.test(v) ||
              "IFSC must be Valid"
            );
          }
      ],
      ifsccode:null,
      accountLocation:null,
      accountHolderName: null,
      accountnumber:null,
      epfnumber:null,
      basicSalary: null,
    };
  },
  created() {
    this.$bindAsArray("hrList", this.$root.$firebaseRefs.hrs.orderByChild('brand').equalTo(this.selectedBrand));
    // this.$bindAsObject('brands',this.$root.$firebaseRefs.brand.orderByChild('brand').equalTo(this.selectedBrand)),
    this.$bindAsArray("godawns", this.$root.$firebaseRefs.godawn.orderByChild('brand').equalTo(this.selectedBrand))
    this.$bindAsArray("godawnTrans", this.$root.$firebaseRefs.godawnTransaction.orderByChild('brand').equalTo(this.selectedBrand))
    // this.$bindAsArray('hrGroups', this.$root.$firebaseRefs.hrGroup)
    this.$bindAsArray("batch", this.$root.$firebaseRefs.batchTransaction.orderByChild('brand').equalTo(this.selectedBrand))
    this.$bindAsArray("damage", this.$root.$firebaseRefs.damageTransaction.orderByChild('brand').equalTo(this.selectedBrand))
    this.$bindAsArray("firms", this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand))
    if(this.$route.params.isNew) {
      this.addHr();
    }
  },
  computed: {
    ...mapGlobalGetters(["selectedBrand","finYear","roleAndPermission"]),
    ...mapGlobalGetters({ units: "hrUnit" }),
    ...mapGlobalGetters({
      gIdentityType: "identityType",
      gVillage: "village",
      gBlock: "block",
      gTehsil: "tehsil",
      gDistrict: "district",
      gState: "state",
      gCountry: "country",
      gGender: "gender",
      gMarital: "marital"
    }),
    firmsByBrand() {
      let firmsB =  this.firms
        .filter((item) => item["brand"] === this.selectedBrand)
        .map((item) => {
          if (item.defaultFirm) {
              this.defaultFirm = item[".key"];
              this.currentHr.businessType = item["businessType"];
          }
          return {
            text: item["name"],
            value: item[".key"],
          };
        });
        return firmsB;
    },
   
    hasHrAddPermission(){
      if(this.roleAndPermission && 
      this.roleAndPermission.permissions && 
      this.roleAndPermission.permissions.length && 
      this.roleAndPermission.permissions.indexOf('PRODUCT_ADD')>-1) {
        return true;
      } else {
        return false;
      }
    },

    hasHrEditPermission(){
      if(this.roleAndPermission && 
      this.roleAndPermission.permissions && 
      this.roleAndPermission.permissions.length && 
      this.roleAndPermission.permissions.indexOf('PRODUCT_EDIT')>-1) {
        return true;
      } else {
        return false;
      }
    },
    
    hasHrDeletePermission(){
      if(this.roleAndPermission && 
      this.roleAndPermission.permissions && 
      this.roleAndPermission.permissions.length && 
      this.roleAndPermission.permissions.indexOf('PRODUCT_DELETE')>-1) {
        return true;
      } else {
        return false;
      }
    },
    
    hasHrTransferPermission(){
      if(this.roleAndPermission && 
      this.roleAndPermission.permissions && 
      this.roleAndPermission.permissions.length && 
      this.roleAndPermission.permissions.indexOf('PRODUCT_TRANSFER')>-1) {
        return true;
      } else {
        return false;
      }
    },
    identityNumeberError() {
      if(this.identityNumber.value) {
        let error = null;
        switch(this.identityType.value) {
          case "Voter ID":
            // 3 alpha, 7 digit 
            error = /^([a-zA-Z]){3}([0-9]){7}?$/g.test(this.identityNumber.value) ? null : 'Enter valid Voter ID';
            break;
          case"Adhaar ID":
            // 16 or 12 digit number 
            error = /^(\d{16}|\d{12})$/g.test(Number(this.identityNumber.value)) ? null : 'Enter valid Adhaar ID'
            break;
          case"Driving License":
            // 2 alpha, 2 digit, 4 digit, 7 digit  
            error = /^([a-zA-Z]{2})(\d{2})(\d{4})(\d{7})$/g.test(this.identityNumber.value) ? null : 'Enter valid Driving License'
            break;
          case"Pan Card":
            // 5 alpha, 4 digit, 1 alpha 
            error = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}$/g.test(this.identityNumber.value) ? null : 'Enter valid PAN Card'
            break;
          case"Samagra Id":
            // 9 digit number  
            error = /^(\d{9})$/g.test(Number(this.identityNumber.value)) ? null : 'Enter valid Samagra ID'
            break;
          default: 
            error = 'Select Identity type';
            break;
        }
        return error;
      }
    },
    
    hrListByBrand() {
      let prod = this.hrList.filter(
        item => {
          return (item["brand"] === this.selectedBrand 
          // && (item.dateOfJoining ? (item.dateOfJoining >= this.finYear.start) && (item.dateOfJoining <= this.finYear.end) : true) 
          && (!!this.search ? !!item["name"].toLowerCase().includes(this.search.toLowerCase()) : true))
        }
      );
      if(!this.suggestionAdded) {
        this.compositionSuggestions =[];
      }
      prod.map((p)=>{
        if(!this.suggestionAdded) {
          if(p.composition && this.compositionSuggestions.indexOf(p.composition)==-1) {
            this.compositionSuggestions.push(p.composition)
          }
        }
        if(p.unitsDeatilsAdded) {
          p['openingQuantityTitle']= this.getFilteredQuantity(p,p['openingQuantity'])
          p['purchaseQuantityTitle']= this.getFilteredQuantity(p,p['purchaseQuantity'])
          p['saleQuantityTitle']= this.getFilteredQuantity(p,p['saleQuantity'])
          p['closingQuantityTitle']= this.getFilteredQuantity(p,((Number.parseFloat(p['openingQuantity']) + Number.parseFloat(p['purchaseQuantity'])) -  Number.parseFloat(p['saleQuantity'])))
        }
      })
      return prod;
    },
    // hrGroupListByBrand() {
    //   return this.hrGroups
    //     .filter(item => {
    //       return (
    //         item["brand"] === this.selectedBrand
    //       );
    //     })
    //     .map(item => {
    //       return {
    //         text: item["name"],
    //         value: item[".key"]
    //       };
    //     });
    // },
    // godawnByBrand() {
    //   return this.godawns
    //     .filter(item => {
    //       return (
    //         item["brand"] === this.selectedBrand 
    //       );
    //     })
    // },
    // getLastUnit() {
    //   let lastUnit = _.maxBy(this.currentHr.unitsDetails, 'order');
    //   return lastUnit ? lastUnit.unit : '';
    // },
    // getLastRate() {
    //   let lastUnit = _.maxBy(this.currentHr.unitsDetails, 'order');
    //   return lastUnit ? lastUnit.rate : '';
    // }
  },
  methods: {
    // addComposition(e){
    //   this.suggestionAdded = true;
    //   this.compositionSuggestions.push(e.target.value)
    // },
    //  getBusinessType(){
    //   let firm = this.firms.filter((item) => item[".key"] === this.currentHr['firm'])[0];
    //   this.currentHr.businessType = firm['businessType'];
    // },
    //   getFilteredQuantity(hr,qty){
    //   let quantity = qty;
    //   let string = "";
    //       hr.unitsDetails.sort(function(a,b){
    //         return (new Date(b.order) - new Date(a.order));
    //       });
    //       for (var i = 0; i < hr.unitsDetails.length; i++) {
    //          if(quantity > Number.parseFloat(hr.unitsDetails[i].quantity) && i+1 <hr.unitsDetails.length) {
    //           let temp  = Number.parseFloat(quantity)/Number.parseFloat(hr.unitsDetails[i].quantity);
    //             string = (("("+((temp).toString().split(".")[1] ? (temp).toString().split(".")[1] : 0) + " "+hr.unitsDetails[i].unit+") ")+ string);
    //             quantity = Number.parseInt((temp).toString().split(".")[0])
    //           } else {
    //             string = (("("+quantity + " "+hr.unitsDetails[i].unit+") ")+ string);
    //             break;
    //           }
    //       }
    //       console.log(string)
    //     return string;
    // },
    // addUnitData(data){
    //   delete data['isLast']
    //   this.currentHr.unitsDetails.push({
    //     unit:'',
    //     order : data.order+1,
    //     quantity : 0,
    //     isLast : true,
    //   })
    // },
    // removeUnitData(){
    //   this.currentHr.unitsDetails.pop();
    //   this.currentHr.unitsDetails[this.currentHr.unitsDetails.length-1]['isLast'] = true;
    // },
    // transferToGodawn(){
    //   let transferObj = {
    //     quantity : Number.parseFloat(this.transferQuantity),
    //     date : new Date(this.transferDate).getTime(),
    //     hr : this.hrToTansfer['.key'],
    //     godawn : this.currentGodawn['.key'],
    //     brand : this.selectedBrand
    //   }
    //   this.$root.$firebaseRefs.godawnTransaction.push(transferObj);
    //   let key = this.hrToTansfer[".key"];
    //   delete this.hrToTansfer[".key"];
    
    //   this.transferDialog = false;
    //   this.transferQuantity = 0;
    //   this.currentGodawn = null;
    //   this.hrToTansfer = null;
    //   this.transferDate =  new Date().toISOString().substr(0, 10);
    // },
    // transferToDamage(){
    //   let damageObj = {
    //     quantity : Number.parseFloat(this.damageQuantity),
    //     date : new Date(this.damageDate).getTime(),
    //     hr : this.hrToDamage['.key'],
    //     brand : this.selectedBrand
    //   }
    //   this.$root.$firebaseRefs.damageTransaction.push(damageObj);
    //   let key = this.hrToDamage[".key"];
    //   delete this.hrToDamage[".key"];
    //   this.hrToDamage['quantity'] = this.hrToDamage['quantity'] - damageObj.quantity;
    //   this.$root.$firebaseRefs.hrs.child(key).set(this.hrToDamage);
      
    //   this.damageDialog = false;
    //   this.damageQuantity = 0;
    //   this.hrToDamage = null;
    //   this.damageDate =  new Date().toISOString().substr(0, 10);
    // },
    // addToBatch(){
    //   let batchObj = {
    //     quantity : Number.parseFloat(this.batchQuantity),
    //     manufacturingDate : new Date(this.manufacuturingDate).getTime(),
    //     expiryDate : new Date(this.expiryDate).getTime(),
    //     hr : this.hrToBatch['.key'],
    //     batchNumber: this.batchNumber,
    //     brand : this.selectedBrand
    //   }
    //   this.$root.$firebaseRefs.batchTransaction.push(batchObj);
    //   let key = this.hrToBatch[".key"];
    //   delete this.hrToBatch[".key"];
      
    //   this.batchDialog = false;
    //   this.batchQuantity = 0;
    //   this.batchNumber ="";
      
    //   this.hrToBatch = null;
    //   this.manufacuturingDate =  new Date().toISOString().substr(0, 10);
    //   this.expiryDate =  new Date().toISOString().substr(0, 10);
    // },
    // openTansferDialog(hr){
    //   this.hrToTansfer = hr;
    //   this.transferDialog = true;
    // },
    // openBatchDialog(hr){
    //   this.hrToBatch = hr;
    //   this.batchDialog = true;
    // },
    // viewHrByBatch(hr){
    //   this.batchSelectedHr = hr;
    //   this.viewBatchDialog = true;
    //   this.bachList = this.batch.filter(item => item["brand"] === this.selectedBrand
    //     && item['hr'] == hr['.key'])
    // },
    // openDamageDialog(hr){
    //   this.hrToDamage = hr;
    //   this.damageDialog = true;
    // },
    capitalize(s){
      s= s.toLowerCase();
      if (typeof s !== 'string') return ''
      return s.charAt(0).toUpperCase() + s.slice(1)
    },
    getBankDetailsFromIFSC(isEdit){
     
      let ifsc = isEdit ? this.ifsccodeEdit : this.ifsccode;
      let reg = /^([a-zA-Z]){4}([0]){1}([a-zA-Z0-9]){6}?$/;
       console.log(ifsc)
      if(ifsc && reg.test(ifsc)) {
          console.log("change")
           axios
          .get('https://ifsc.razorpay.com/'+ifsc)
          .then(response => {
            this.gState.push(this.capitalize(response.data.STATE));
            this.gDistrict.push(this.capitalize(response.data.DISTRICT));
            this.gTehsil.push(this.capitalize(response.data.CITY));
            setTimeout(() => {
              this.country.value = 'India';
              this.district.value = this.capitalize(response.data.DISTRICT);
              this.state.value = this.capitalize( response.data.STATE);
              this.tehsil.value = this.capitalize(response.data.CITY);
            }, 100);
            if(isEdit) {
              this.accountLocationEdit = response.data.BRANCH + " " +  response.data.ADDRESS;
            } else {
              this.accountLocation = response.data.BRANCH + " " +  response.data.ADDRESS;
            }
          })
      }
    },
    duplicateCheck(){
       let duplicateCheck = this.hrList.filter(
        item => item["brand"] === this.selectedBrand
        && item['name'] == this.currentHr.name
      );
      if(duplicateCheck.length) {
          this.duplicateError = 'Hr with name ' + this.currentHr.name + ' Already exist.';
                setTimeout(() => {
                    this.duplicateError = null;
          }, 3000);
      }
    },
    saveHr() {
      if(this.currentHr.unitsDeatilsAdded) {
        this.currentHr.unit = this.getLastUnit;
      } else {
        delete this.currentHr['unitsDetails']
      }
      let duplicateCheck = this.hrList.filter(
        item => item["brand"] === this.selectedBrand
        && item['name'] == this.currentHr.name
      );
      console.log(duplicateCheck)
      if(duplicateCheck.length) {
          this.duplicateError = 'Hr with name ' + this.currentHr.name + ' Already exist.';
                setTimeout(() => {
                    this.duplicateError = null;
          }, 3000);
      } else {
        this.currentHr["brand"] = this.selectedBrand;
        this.currentHr["age"] = this.currentHr.age;
        this.currentHr["gender"] = this.currentHr.gender;
        this.currentHr["mobile"] = this.currentHr.mobile;
        this.currentHr["email"] = this.currentHr.email;

        this.currentHr["bankName"] = this.currentHr.bankName;
        this.currentHr["accountType"] = this.currentHr.accountType;
        this.currentHr["accountNumber"] = this.currentHr.accountNumber;
        this.currentHr["accountHolderName"] = this.currentHr.accountHolderName;
        // this.currentHr["accountLocation"] = this.currentHr.accountLocation;
        // this.currentHr["ifsccode"] = this.currentHr.ifsccode;
        
        this.currentHr["StaffId"] = this.currentHr.StaffId;
        this.currentHr["staffDesignationCategory"] = this.currentHr.staffDesignationCategory;
        this.currentHr.purchaseQuantity = 0;
        this.currentHr.saleQuantity = 0;
        this.currentHr.openingQuantity = this.currentHr.quantity;
        this.currentHr.dateOfJoining = new Date(this.currentHr.dateOfJoining).getTime()
        this.currentHr.dateOfBirth = new Date(this.currentHr.dateOfBirth).getTime()
        delete this.currentHr['openingQuantityTitle'];
        delete this.currentHr['purchaseQuantityTitle'];
        delete this.currentHr['saleQuantityTitle'];
        delete this.currentHr['closingQuantityTitle'];
        this.$root.$firebaseRefs.hrs.push(this.currentHr);
        this.addHrDialog = false;
        this.snackbar = true;
      }
    },
    keymonitor(event){
      this.search = event.target.value;
    },
    addHr() {
      this.stepper = 1;
      this.currentHr = {
        firm : this.defaultFirm,
        name: "",
        age: 0,
        gender: "",
        marital: "",
        description: "",
        currentAddressDescription: "",
        currentAccountType: "",
        currentBankName:"",
        currentContractType: "",
        currentWorkShift: "",
        currentEmployeeQualification: "",
        currentPermanentDescription: "",
        StaffId: 0,
        Designation: "",
        staffDesignationCategory: "",
        barcode:"",
        hrGroup: null,
        unit: "",
        quantity: 0,
        batchNumber: "",
        dateOfJoining : new Date().toISOString().substr(0, 10),
        dateOfBirth : new Date().toISOString().substr(0, 10),
        brand: "",
        basicPrice : 0,
        gstValue : 0,
        purchasingPrice: null,
        sellingPrice: null,
        openingBalance: null,
        purchasingPricePerHr: null,
        basicSalary: 0,
        netSalary: 0,
        generalConveyance : 0,
        medicalConveyance : 0,
        specialConveyance : 0,
        casualLeave: 0,
        epfAmount: 0,
        esiAmount: 0,
        tdsAmunt: 0,
        professionalTaxAmount: 0,
        unitsDetails : [
          {
            unit:'',
            isLast: true,
            isFirst:true,
            order : 1,
            quantity : 0
          }
        ]
      };
      this.addHrDialog = true;
    },
    updateHr() {
      if(this.currentHr.unitsDeatilsAdded) {
        this.currentHr.unit = this.getLastUnit;
      } else {
        delete this.currentHr['unitsDetails']
      }
      let key = this.currentHr[".key"];
      delete this.currentHr[".key"];
      this.currentHr.dateOfJoining = new Date(this.currentHr.dateOfJoining).getTime()
      this.currentHr.dateOfBirth = new Date(this.currentHr.dateOfBirth).getTime()      
      this.currentHr.openingQuantity = this.currentHr.quantity;
      this.currentHr["age"] = this.currentHr.age;
      this.currentHr["gender"] = this.currentHr.gender;
      this.currentHr["StaffId"] = this.currentHr.StaffId;
      this.currentHr["marital"] = this.currentHr.marital;
      this.currentHr["mobile"] = this.currentHr.mobile;
      this.currentHr["email"] = this.currentHr.email;

      this.currentHr["bankName"] = this.currentHr.bankName;
      this.currentHr["accountType"] = this.currentHr.accountType;
      this.currentHr["accountNumber"] = this.currentHr.accountNumber;
      this.currentHr["accountHolderName"] = this.currentHr.accountHolderName;
      this.currentHr["accountLocation"] = this.currentHr.accountLocation;
      this.currentHr["ifsccode"] = this.currentHr.ifsccode;
      
      this.currentHr.quantity = ((Number.parseFloat(this.currentHr.openingQuantity) + Number.parseFloat(this.currentHr.purchaseQuantity)) - Number.parseFloat(this.currentHr.saleQuantity))
      delete this.currentHr['openingQuantityTitle'];
      delete this.currentHr['purchaseQuantityTitle'];
      delete this.currentHr['saleQuantityTitle'];
      delete this.currentHr['closingQuantityTitle'];
      this.$root.$firebaseRefs.hrs.child(key).set(this.currentHr);
      this.currentHr = {
        name: "",
        age:"",
        gender:"",
        description: "",
        currentAddressDescription: "",
        currentPermanentDescription: "",
        currentAccountType: "",
        currentContractType: "",
        contractType:"",
        currentWorkShift:"",
        workShift:"",
        employeeQualification:"",
        currentEmployeeQualification: "",
        currentBankName: "",
        StaffId: 0,
        Designation: "",
        staffDesignationCategory: 0,
        barcode:"",
        quantity: 0,
        unit: "",
        dateOfJoining : new Date().toISOString().substr(0, 10),
        brand: "",
        basicPrice : 0,
        gstValue : 0,
        purchasingPrice: null,
        sellingPrice: null,
        openingBalance: null,
        basicSalary: 0,
        netSalary: 0,
        generalConveyance : 0,
        medicalConveyance : 0,
        specialConveyance : 0,
        casualLeave: 0,
        epfAmount: 0,
        esiAmount: 0,
        tdsAmunt: 0,
        professionalTaxAmount: 0,
      };
      this.addHrDialog = false;
      this.snackbar = true;
    },
    editHr(hr) {
      this.currentHr = JSON.parse(JSON.stringify(hr));
      this.currentHr.dateOfJoining = this.currentHr.dateOfJoining ? new Date(this.currentHr.dateOfJoining).toISOString().substr(0, 10) :  new Date().toISOString().substr(0, 10);
      this.currentHr.quantity = this.currentHr.openingQuantity;
      this.currentHr.age = this.currentHr.age;
      this.currentHr.gender = this.currentHr.gender;
      this.currentHr.mobile = this.currentHr.mobile;
      this.currentHr.email = this.currentHr.email;
      this.currentHr.marital = this.currentHr.marital;
      this.currentHr.StaffId = this.currentHr.StaffId;
      this.currentHr.name = this.currentHr.name;
      this.currentHr.basicSalary = this.currentHr.basicSalary;
      this.currentHr.netSalary = this.currentHr.netSalary;
      this.currentHr.generalConveyance = this.currentHr.generalConveyance;
      this.currentHr.specialConveyance = this.currentHr.specialConveyance;
      this.currentHr.medicalConveyance = this.currentHr.medicalConveyance;
      this.currentHr.epfAmount = this.currentHr.epfAmount;
      this.currentHr.esiAmount = this.currentHr.esiAmount;
      this.currentHr.professionalTaxAmount = this.currentHr.professionalTaxAmount;
      this.currentHr.tdsAmunt = this.currentHr.tdsAmunt;
      this.currentHr.casualLeave = this.currentHr.casualLeave;
      this.currentHr.bankName = this.currentHr.bankName;
      this.currentHr.accountType = this.currentHr.accountType;
      this.currentHr.accountNumber = this.currentHr.accountNumber;
      this.currentHr.accountHolderName = this.currentHr.accountHolderName;
      // this.currentHr.accountLocation = this.currentHr.accountLocation;
      // this.currentHr.ifsccode = this.currentHr.ifsccode;
      this.addHrDialog = true;
      if(!this.currentHr.unitsDeatilsAdded) {
        this.currentHr.unitsDetails = [
          {
            unit:'',
            isLast: true,
            isFirst:true,
            order : 1,
            quantity : 0
          }
        ]
      }
    },
    deleteHr(hr) {
      if (window.confirm("Do you want to Delete " + hr.name + "?")) {
        this.$root.$firebaseRefs.hrs.child(hr[".key"]).remove();
      }
    },
    // calculateOpeningBalance() {
    //   this.currentHr.openingBalance = Number.parseFloat(this.currentHr.basicPrice) + Number.parseFloat(this.currentHr.gstValue);
    // }
  },
  watch: {
    "currentHr.Designation": {
      handler(newVal, oldVal) {
        if (newVal != "Teacher") {
          this.currentHr.staffDesignationCategory = 0;
        }
      },
      deep: true
    },
    //  "currentHr.basicPrice": {
    //   handler(newVal, oldVal) {
    //     if (newVal != oldVal) {
    //       this.calculateOpeningBalance();
    //     }
    //   },
    //   deep: true
    // },
    // "currentHr.firm": {
    //   handler(newVal, oldVal) {
    //     if (newVal != oldVal) {
    //       this.getBusinessType();
    //     }
    //   },
    //   deep: true
    // },
    // "currentHr.gstValue": {
    //   handler(newVal, oldVal) {
    //     if (newVal != oldVal) {
    //       this.calculateOpeningBalance();
    //     }
    //   },
    //   deep: true
    // }
  }
};
</script>
<style>
.search .theme--light.v-input:not(.v-input--is-disabled) input, .theme--light.v-input:not(.v-input--is-disabled) textarea {
    color: rgb(255, 255, 255);
}

.search .theme--light.v-label {
  color: rgb(255, 255, 255);
}

.search .theme--light.v-clearable {
  color: rgb(255, 255, 255);
}

.search .theme--light.v-outlined {
  color: rgb(255, 255, 255);
  border-color: white;
}

.search {
  width: 50%;
  margin-left: 7%;
  margin-right: 7%;
}

.search .v-text-field > .v-input__control > .v-input__slot:after {
    border-color: white;
}
.address .v-textarea {
  color: blue;
  background-color: black;
}

.search .theme--light.v-text-field > .v-input__control > .v-input__slot:before {
    border-color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/Settings/StaffAttendance/staffAttendance.vue